// Site branding (name, logo, tagline, accent) — set in the admin panel, read
// everywhere via <Brand>. The accent is pushed to the CSS var --accent.
import { create } from 'zustand'
import { getBranding } from '../api/gg'
import type { Branding } from '../types'

const DEFAULT: Branding = {
  name: 'GoonGallery',
  logoUrl: null,
  tagline: 'Speed through the gallery. Hit the buzzer. Goon.',
  accent: '#ff2d9b',
}

interface BrandingState {
  branding: Branding
  loaded: boolean
  load: () => Promise<void>
  apply: (b: Branding) => void
}

export const useBranding = create<BrandingState>((set, get) => ({
  branding: DEFAULT,
  loaded: false,
  async load() {
    try {
      const b = await getBranding()
      get().apply(b)
      set({ loaded: true })
    } catch {
      set({ loaded: true })
    }
  },
  apply(b) {
    set({ branding: b })
    if (b.accent) document.documentElement.style.setProperty('--accent', b.accent)
    if (b.name) document.title = b.name
  },
}))
